module.exports = __webpack_public_path__ + "static/media/kypsien-rypskyjen-tutkailua.5ad86095.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/kypsien-rypskyjen-tutkailua.jpg
 ** module id = 323
 ** module chunks = 0
 **/